



export class ClientUserVM {
    
    id?: string;
    
    email?: string;
    
    password?: string;
    
    locked?: boolean;
    
    verified?: boolean;
    
}
